import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PortalWrapper extends React.Component {
  static propTypes = {
    onOutClick: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);

    this.node = document.createElement('div');
    this.root = null;
    this.handleRootRef = root => {
      this.root = root;
    };

    this.handleOutClick = e => {
      const { onOutClick } = this.props;
      if (typeof onOutClick === 'function') {
        if (this.root && !this.root.contains(e.target)) {
          onOutClick(e);
        }
        if (!this.root) {
          onOutClick(e);
        }
      }
    };

    document.addEventListener('click', this.handleOutClick, true);
  }
  componentDidMount() {
    document.body.appendChild(this.node);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutClick, true);
    document.body.removeChild(this.node);
  }

  render() {
    const { onOutClick, ...props } = this.props;

    return ReactDOM.createPortal(
      <div {...props} ref={this.handleRootRef} />,
      this.node
    );
  }
}

export { PortalWrapper };



// WEBPACK FOOTER //
// ./src/common/Components/RelativePortal/PortalWrapper.js